'use client'

import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import React, { useMemo } from 'react'

// Only load Stripe if we have a publishable key
const getStripePromise = () => {
  const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
  if (!publishableKey) {
    return null
  }
  return loadStripe(publishableKey)
}

export function StripeProvider({ children }: { children: React.ReactNode }) {
  const stripePromise = useMemo(() => getStripePromise(), [])
  
  // If no Stripe key, just render children without Stripe Elements
  if (!stripePromise) {
    return <>{children}</>
  }
  
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  )
}

